import React from "react";
import "./styles.scss";

const NextStep = (props) => {
  const { description, title, description_for_low_score } = props;

  return (
    <div className="next-step-container">
      <div className="h3">
        <h3>Your next steps</h3>
      </div>
      <div className="description">
        <h4>{title}<span>:</span></h4>
        <p
          dangerouslySetInnerHTML={{
            __html: description_for_low_score?.length
              ? description_for_low_score
              : description,
          }}
        />
      </div>
    </div>
  );
};

export default NextStep;
